const words = ["reconhecimento", "autenticação", "apostilamento", "registro", "casamento", "nascimento"]
const min = ["rec.", "aut.", "apos.", "reg.", "cas.", "nasc.",]
const remove = [" de ", " por ", " para ", " em "]
export default class StringUtils
{
    public static Replace(text : string, old : string, content: string)
    {
        if(!text || text.length == 0)
            return "";
        
        while(text.indexOf(old) > -1)
            text = text.replace(old, content);
        return text;
    }
   
    public static FormatToChartLabel(text : string)
    {
        
        if(!text || text.length == 0)
            return "";

        let limit = 22; 
        
        if(text.length <= limit)
            return text;

        let lower = text.toLowerCase();      
        words.forEach((w, i) => {
            lower = StringUtils.Replace(lower, w, min[i]);
        });
        remove.forEach(s => StringUtils.Replace(lower, s, ""));
        lower = `${lower[0].toUpperCase()}${lower.substring(1)}`;
        if(lower.length > limit)
            return `${lower.substring(0, limit)}...`;
        return lower;
    }

    public static TruncateStringForLabel(text: string)
    {
          if(!text || text.length == 0)
            return "";

           let limit = 22; 

        if(text.length > limit)
            return `${text.substring(0, limit)}...`;
        
        return text;
    }

    public static FormatNumber(value: string)
    {
        if(!value || value.length == 0)
            return "0";

        let number = parseFloat(value);
        if(isNaN(number))
            return "0";

        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    }

    public static MonetaryFormat(value: string)
    {
        if(!value || value.length == 0)
            return "R$ 0,00";

        let number = parseFloat(value);
        if(isNaN(number))
            return "R$ 0,00";

        return "R$ " + number.toFixed(2)
            .replace('.', ',')
            .replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    }
}